module.exports = __webpack_public_path__ + "img/17055.dc973f11.jpg";